import { testIds } from "@/lib/api";

export default function About() {
  return (
    <section
      id="about"
      data-testid={testIds.about.section}
      className="py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-4">
          <div className="overline mb-4">About</div>
          <h2 className="font-serif-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] text-[#2D372B]">
            Hi, You can even call me <span className="italic text-[#AD6A48]">Coach&nbsp;Jay</span>.
          </h2>
          <div className="mt-8 flex items-center gap-3 text-lg text-[#89937C]">
            <span className="h-px w-10 bg-[#89937C]" />
            Professionally Certified Fitness Nutritionist
          </div>
        </div>

        <div className="md:col-span-8 space-y-6 text-lg leading-relaxed text-[#5C665A]">
          <p>
            I spent the first half of my career treating fitness like a
            spreadsheet — reps, macros, PRs. It worked, until it didn't. A
            burnout in my early forties taught me that a body pushed without a
            mind at rest is just a slower breakdown.
          </p>
          <p>
            Since then, my practice has been about integrating the parts we
            usually split. Strength that respects sleep. Nutrition that
            respects the family table. Recovery that isn't just a foam roller.
          </p>
          <p>
            I coach small groups and a few 1:1 clients at a time. If you're
            looking for a coach who counts sleep as training and stress as a
            variable — you're in the right place.
          </p>
        </div>
      </div>
    </section>
  );
}
